import { Box, Typography } from '@mui/material'

interface HeroSectionProps {
    heading: string
    subheading: string
}

const HeroSection: React.FC<HeroSectionProps> = ({ heading, subheading }) => {
    return (
        <Box sx={{ mb: 2 }}>
            {heading && (
                <Typography
                    component="h1"
                    variant="h5"
                    sx={{ fontWeight: 700, fontSize: { xs: '1.15rem', md: '1.5rem' }, mb: subheading ? 1 : 0 }}
                >
                    {heading}
                </Typography>
            )}
            {subheading && (
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                    {subheading}
                </Typography>
            )}
        </Box>
    )
}

export default HeroSection
export type { HeroSectionProps }
